import { render, staticRenderFns } from "./VerticalImageWall.vue?vue&type=template&id=078643ed&scoped=true"
import script from "./VerticalImageWall.vue?vue&type=script&lang=js"
export * from "./VerticalImageWall.vue?vue&type=script&lang=js"
import style0 from "./VerticalImageWall.vue?vue&type=style&index=0&id=078643ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078643ed",
  null
  
)

export default component.exports